var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Outlet, useParams, useOutletContext } from 'react-router-dom';
import { Box, Divider, MemberHeader, PrintWrapper, Spinner, SpringHealthCompanyHeader, } from 'shared/components';
import { NoteSetupProvider, useNoteSetupContext } from 'shared/features/note-setup';
import { ActionType, ResourceType, useAuditLog } from 'shared/hooks/useAuditLog';
var Appointment = function () {
    var appointmentId = useParams().appointmentId;
    return (_jsx(NoteSetupProvider, __assign({ appointmentId: appointmentId !== null && appointmentId !== void 0 ? appointmentId : '' }, { children: _jsx(AppointmentContent, {}) })));
};
var AppointmentContent = function () {
    var _a, _b;
    var _c = useNoteSetupContext(), data = _c.data, error = _c.error, isError = _c.isError, isLoading = _c.isLoading;
    var appointment = (data !== null && data !== void 0 ? data : {}).appointment;
    var memberId = (_a = appointment === null || appointment === void 0 ? void 0 : appointment.member) === null || _a === void 0 ? void 0 : _a.id;
    useAuditLog({
        resource: ResourceType.Appointment,
        action: ActionType.View,
        appointment_id: (_b = appointment === null || appointment === void 0 ? void 0 : appointment.id) !== null && _b !== void 0 ? _b : '',
        member_id: memberId !== null && memberId !== void 0 ? memberId : '',
    }, !!(appointment === null || appointment === void 0 ? void 0 : appointment.id));
    if (isError) {
        return _jsx("div", { children: error });
    }
    if (isLoading) {
        return (_jsx(Box, { children: _jsx(Spinner, { "data-testid": "loading" }) }));
    }
    return (_jsxs(_Fragment, { children: [_jsxs(PrintWrapper, { children: [_jsx(SpringHealthCompanyHeader, { memberId: memberId }), _jsx(Divider, { mb: 2, mt: 3 })] }), _jsx(MemberHeader, __assign({ memberId: memberId || '', prefetchedMember: appointment === null || appointment === void 0 ? void 0 : appointment.member }, { children: _jsx(Outlet, { context: appointment }) }))] }));
};
export var useAppointmentFromContext = function () { return useOutletContext(); };
export default Appointment;
